import { getPlayedExperiments } from '../reducers';

export default (state, { name }) => getPlayedExperiments(state)[name];
